export default class ContentMore {
  constructor (clickedMoreElem, moreElem) {
    clickedMoreElem.addEventListener('click', {
      params: { moreElem: moreElem },
      handleEvent: this.addEvent
    });
  }

  addEvent (event) {
    event.preventDefault();

    this.params.moreElem.children.forEach(function (elem) {
      elem.classList.remove('u-hide');
    });

    event.currentTarget.classList.add('u-hide');
  }
}
